const isAuthenticated = () => localStorage.getItem("token") !== null;

const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminRoleId");
};

export { isAuthenticated, logout };
